import { jsx, jsxs } from "react/jsx-runtime";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { Close } from "../../../icons/index.js";
function createIconsComponent(params) {
  const { handleToggleOpen, handleOnClearInput, focused, mouseIn, isEmpty, fieldHasError, disabled } = params;
  const clearable = !!handleOnClearInput;
  const hasFocusOrOver = focused || mouseIn;
  const showClearButton = !isEmpty && (hasFocusOrOver || fieldHasError);
  return function IconComponent(props) {
    const { className } = props;
    const open = className?.includes("MuiSelect-iconOpen");
    const icon = open ? /* @__PURE__ */ jsx(ArrowDropUp, {}) : /* @__PURE__ */ jsx(ArrowDropDown, {});
    return /* @__PURE__ */ jsxs(Box, { display: "flex", paddingX: 1, children: [
      clearable && /* @__PURE__ */ jsx(
        IconButton,
        {
          sx: {
            padding: 0.5,
            visibility: showClearButton ? "visible" : "hidden"
          },
          tabIndex: showClearButton ? void 0 : -1,
          disabled,
          className: "SimpleSelect__clear",
          onClick: handleOnClearInput,
          "data-id": "clear-btn",
          children: /* @__PURE__ */ jsx(Close, { fontSize: "small" })
        },
        "clear-icon"
      ),
      /* @__PURE__ */ jsx(IconButton, { disabled, sx: { padding: 0.25 }, onClick: handleToggleOpen, children: icon }, "toggle-icon")
    ] }, "icons-root");
  };
}
export {
  createIconsComponent
};
//# sourceMappingURL=createIconsComponent.js.map
